import ApiClient, { AnyObject } from './ApiClient';
import { AxiosResponse } from 'axios';

const DEFAULT_TIMEOUT = 60 * 1000;
const LONG_OPERATION_TIMEOUT = 20 * 60 * 1000;
export class CanvasClient extends ApiClient {
  constructor() {
    super('/canvas/v1');
  }

  async generatePoseAndDepth(request: AnyObject): Promise<AxiosResponse> {
    const url = '/generate_with_pose_and_depth';
    return this.client.post(url, request);
  }

  async createMaskFromPrompt(request: AnyObject): Promise<AxiosResponse>{
    const url = '/create_mask/prompt';
    return this.client.post(url, request);
  }

  async createAutoMasks(request: AnyObject): Promise <AxiosResponse>{
    const url ="/create_mask/auto_segment";
    return this.client.post(url, request);
  }

  async eraseObjects(request: AnyObject): Promise <AxiosResponse>{
    const url ="/eraser";
    return this.client.post(url, request);
  }

  async InpaintObject(request: AnyObject): Promise <AxiosResponse>{
    const url ="/inpainting";
    return this.client.post(url, request);
  }
    
  async removeSubjectBackground(request: AnyObject): Promise<AxiosResponse> {
    const url = '/remove_background';
    return this.client.post(url, request);
  }

  async replaceSubjectBackground(request: AnyObject): Promise<AxiosResponse> {
    const url = '/replace_background';
    return this.client.post(url, request);
  }

  async editSubjectWithText(request: AnyObject): Promise<AxiosResponse> {
    const url = '/edit_subject';
    return this.client.post(url, request, {
      timeout: DEFAULT_TIMEOUT
    });
  }
  
  async outpaintSubject(request: AnyObject): Promise<AxiosResponse> {
    const url = '/outpaint';
    return this.client.post(url, request, {
      timeout: LONG_OPERATION_TIMEOUT
    });
  }

  async upscaleSubject(request: AnyObject): Promise<AxiosResponse> {
    const url = '/upscale';
    return this.client.post(url, request, {
      timeout: LONG_OPERATION_TIMEOUT
    });
  }
  async deblurSubject(request: AnyObject): Promise<AxiosResponse> {
    const url = '/deblur';
    return this.client.post(url, request, {
      timeout: LONG_OPERATION_TIMEOUT
    });
  }

  async denoiseSubject(request: AnyObject): Promise<AxiosResponse> {
    const url = '/denoise';
    return this.client.post(url, request, {
      timeout: LONG_OPERATION_TIMEOUT
    });
  }

  async retouchSubject(request: AnyObject): Promise<AxiosResponse> {
    const url = '/retouch';
    return this.client.post(url, request, {
      timeout: 90 * 1000
    });
  }
}

export const client = new CanvasClient();

export default client;
